import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiFeesProjection from '../../Api/ApiFeesProjection';
import ToastMsg from '../../Components/ToastMsg';
import { creators as FeesProjectionActions } from '../../Reducers/Reporting/FeesProjection';

export function* getFeesProjectionSummary({ payload }) {
  try {
    const response = yield call(
      ApiFeesProjection.getSummary,
      payload.selectedYears,
      payload.DateKey,
    );

    if (response.status === 200) {
      yield put(
        FeesProjectionActions.feesprojectionSuccess({ summaryData: response.data }),
      );
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Fees Projection Summary',
            text: response.message,
          },
        },
      );
      yield put(FeesProjectionActions.feesprojectionFailure(response.message));
    }
  } catch (e) {
    yield put(FeesProjectionActions.feesprojectionFailure(e));
  }
}

export function* getFeesProjectionDetail({ payload }) {
  try {
    const response = yield call(
      ApiFeesProjection.getDetail,
      payload.selectedYears,
      payload.DateKey,
    );

    if (response.status === 200) {
      yield put(
        FeesProjectionActions.feesprojectionSuccess({ detailData: response.data }),
      );
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Fees Projection Detail',
            text: response.message,
          },
        },
      );
      yield put(FeesProjectionActions.feesprojectionFailure(response.message));
    }
  } catch (e) {
    yield put(FeesProjectionActions.feesprojectionFailure(e));
  }
}
